import React from 'react';

type NotificationContextType = {
  close: () => void;
} | null;

export const NotificationContext =
  React.createContext<NotificationContextType>(null);
